var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconExpand = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30294 1.16602V2.46232H11.7372L5.0625 8.8336L6.02331 9.75074L12.698 3.37943V5.70304H14.056V1.16602H9.30294Z",
    fill: "#E5E4EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6977 11.5364H3.19153V2.46232H7.94461V1.16602H3.19153C2.4412 1.16602 1.8335 1.7461 1.8335 2.46232V11.5364C1.8335 12.2526 2.4412 12.8327 3.19153 12.8327H12.6977C13.448 12.8327 14.0557 12.2526 14.0557 11.5364V6.99935H12.6977V11.5364Z",
    fill: "#E5E4EC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconExpand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-expand.c1ad2e6b0d4f518b685dd1523096a743.svg";